export const QUERY_KEYS = {
  PRODUCT_DETAIL: 'productDetail',
  CREDIT_ACCOUNT_VALIDATION: 'creditAccountValidation',
}
